import { bySnapshotOrder } from '@sportninja/common/features/game/attendance/utils/availabilityOrder'
import type { AttendancePlayer } from '../types'
import { getSortMethod } from './sections'

export interface OrderAttendanceRowsParams {
  list: AttendancePlayer[]
  sortType: string
  sortOrder: 'asc' | 'desc'
  hasUserSorted: boolean
  // Frozen id → position snapshot from buildAvailabilityOrder.
  availabilityOrder: Record<string, number>
  isSpareCandidate: boolean
  spareCandidatesLast: boolean
  promotedRequestById?: Record<string, string>
}

/**
 * Row order for an attendance section. The grid renders rows in exactly this
 * order (its own sorting is off), so this is the single source of truth.
 *
 * Roster / Roster Spares group by availability, but from a SNAPSHOT taken when
 * the list first loads (and again when the user taps AVAILABLE) — using live
 * statuses would make a row jump the moment its status is set. An explicit
 * column sort takes over; Eligible Game Spares have no status.
 */
export const orderAttendanceRows = ({
  list,
  sortType,
  sortOrder,
  hasUserSorted,
  availabilityOrder,
  isSpareCandidate,
  spareCandidatesLast,
  promotedRequestById,
}: OrderAttendanceRowsParams): AttendancePlayer[] => {
  const columnSort = getSortMethod(sortType, sortOrder)
  const groupByAvailability = !isSpareCandidate && !hasUserSorted
  const sorted = [...list].sort(
    groupByAvailability
      ? bySnapshotOrder(availabilityOrder, columnSort)
      : columnSort
  )
  if (spareCandidatesLast && !hasUserSorted && promotedRequestById) {
    return [
      ...sorted.filter((p) => !promotedRequestById[p.id]),
      ...sorted.filter((p) => !!promotedRequestById[p.id]),
    ]
  }
  return sorted
}
